import type { RouteObject } from 'react-router';
import { SettingsPage } from './pages/settings-page';

export const settingsRoutes: RouteObject[] = [
  { path: 'settings', element: <SettingsPage /> },
];
